import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import realEstateLogo from "../images/brand/logo1.png";
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { Toaster, toast } from 'react-hot-toast';

function Forget() {
  const location = useLocation();
  const { user } = useUser();
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user]);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [email, setEmail] = useState("")
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState();
  const navigate = useNavigate();
  function validateEmail (value){
    setEmail(value);
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        setError(true);
        setErrorValue("Please enter a valid email address");
    } else {
        setError(false);
        setErrorValue("");
    }
  }
  useEffect(() => {
    if(email){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [email]);

  const queryParams = new URLSearchParams(location.search);
  const usertype = queryParams.get("type");

  const handleForget = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/forget.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_forget: true, email: email})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  } 

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
      <div><Toaster/></div>
      <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={(usertype && usertype === "realestate") ? realEstateLogo : logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
          Back to homepage
        </Link>
      </header>
      <main className="flex-grow-1 d-flex justify-content-center p-3 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 col-xl-4">
              <div className="mb-4">
                <h1 className="fs-4 fw-semibold">Reset your password</h1>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type="email"
                    className="form-control py-2"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => validateEmail(e.target.value)}
                    required
                  />
                </div>
                {error && (
                  <p className="mb-0 text-danger fs-7 mt-1">{errorValue}</p>
                )}
              </div>
              <div className="d-flex flex-column my-4">
                <Link to={(usertype && usertype === "realestate") ? '/register?type=realestate' : '/register'} className="text-prime fw-bold mb-2 noLink">
                  Don't have an account?
                </Link>
                <Link to={(usertype && usertype === "realestate") ? '/login?type=realestate' : '/login'} className="text-prime fw-bold mb-2 noLink">
                  Remembered your password?
                </Link>
              </div>
              <div className={`btn btn-secondary w-100 py-2 fw-bold ${disable?'disabled':null}`} onClick={!disable ? handleForget : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Reset your password'}</div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Forget